import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import PublicFooter from '../components/PublicFooter';
import usePageMeta from '../utils/usePageMeta';

export default function Products() {
  usePageMeta(
    'Tactmark Products | Post-Match and Federation',
    'Tactmark Post-Match supports team-level match review and coaching decisions. Tactmark Federation supports organization-level technical development, program oversight, accountability, and reporting.'
  );

  return (
    <div className="min-h-screen bg-white">
      <PublicNav />

      <div className="max-w-4xl mx-auto px-6 pt-16 pb-10">
        <p className="text-navy-600 text-xs font-semibold tracking-widest uppercase mb-4">Products</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-navy-900 leading-tight mb-6">
          Two focused products for different levels of football responsibility.
        </h1>
        <p className="text-gray-600 text-lg leading-relaxed max-w-3xl">
          Tactmark Post-Match supports team-level match review and coaching decisions. Tactmark Federation supports organization-level technical development, program oversight, accountability, and reporting.
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-6 pb-20 space-y-6">
        <div className="border border-gray-200 rounded p-8">
          <p className="text-navy-600 text-xs font-semibold tracking-widest uppercase mb-3">For coaches and teams</p>
          <h2 className="font-serif text-2xl sm:text-3xl text-navy-900 mb-4">Tactmark Post-Match</h2>
          <p className="text-gray-600 leading-relaxed mb-6 max-w-2xl">
            Review completed matches, confirm findings, make coaching decisions, assign training responses, and review outcomes in later matches.
          </p>
          <Link
            to="/products/post-match"
            className="inline-flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-medium px-5 py-2.5 rounded transition-colors"
          >
            Explore Post-Match
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="border border-gray-200 rounded p-8">
          <p className="text-navy-600 text-xs font-semibold tracking-widest uppercase mb-3">For football associations</p>
          <h2 className="font-serif text-2xl sm:text-3xl text-navy-900 mb-4">Tactmark Federation</h2>
          <p className="text-gray-600 leading-relaxed mb-6 max-w-2xl">
            Define development objectives, standardize program reporting, oversee execution across teams and programs, and produce organization-level development evidence.
          </p>
          <Link
            to="/products/federation"
            className="inline-flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-medium px-5 py-2.5 rounded transition-colors"
          >
            Explore Federation
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
}
